<template>
	<div class="container">
		<div class="jiangli_top">
			<img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
			<p class="">{{ $t('m.kf_span0') }}</p>
		</div>
		<iframe
			v-if="reportUrl"
			:src="reportUrl"
			style="border:none;margin-top:45px;"
			:width="searchTableWidth"
			:height="searchTableHeight"
			frameborder="0"
			allowfullscreen
		></iframe>
		<div v-else-if="loading" class="kf-empty">加载中...</div>
		<div v-else class="kf-empty">客服链接未配置，请联系管理员</div>
		<div style="height: 50px;"></div>
	</div>
</template>
<script>
import request from '@utils/request';
export default {
	name: 'CustomerService',
	data() {
		const cachedKf = this.$store.state.app.kf;
		return {
			reportUrl: cachedKf || '',
			loading: !cachedKf,
			searchTableHeight: 0,
			searchTableWidth: 0
		};
	},
	mounted() {
		this.searchTableHeight = window.innerHeight - 95;
		this.searchTableWidth = window.innerWidth;
		request.get('/shop/sign/status', {}, { login: true });
		this.loadKfUrl();
	},
	methods: {
		loadKfUrl() {
			if (!this.reportUrl) {
				this.loading = true;
			}
			request
				.get('/getkf', {}, { login: false })
				.then(res => {
					const url = (res.data && res.data.data) || this.$store.state.app.kf;
					this.applyKfUrl(url);
				})
				.catch(() => {
					this.applyKfUrl(this.$store.state.app.kf);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		applyKfUrl(url) {
			if (!url) {
				this.reportUrl = '';
				return;
			}
			this.reportUrl = url;
			this.$store.commit('SET_KF', url);
			console.log('客服地址：' + url);
		},
		onClickLeft() {
			this.$router.go(-1);
		}
	}
};
</script>

<style scoped lang="less">
iframe {
	height: calc(~'84vh - 50px');
}
.kf-empty {
	margin-top: 120px;
	text-align: center;
	color: #999;
	font-size: 14px;
}
.jiangli_top {
	width: 100%;
	height: 45px;
	line-height: 45px;
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
}
.jiangli_top img {
	height: 30px;
	width: 30px;
	position: absolute;
	left: 0px;
}
.jiangli_top p {
	font-size: 18px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
	text-align: center;
}
</style>
